import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Input, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { ActivityProviderService } from '../activity-provider.service';
import { ActivityProvider } from '../activity-provider';
import { ActivityProviderComponent } from '../activity-provider/activity-provider.component';

@Component({
    selector: 'app-activity-provider-list',
    templateUrl: './activity-provider-list.component.html',
    styleUrls: ['./activity-provider-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class ActivityProviderListComponent implements OnInit {
	constructor(
		private activityProviderService: ActivityProviderService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = activityProviderService.statuses
	}



	// data
	activityProviders: any;
	activityProvider: ActivityProvider;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'activityProviderId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'status', header: 'Status', width: 'auto' },
		{ field: 'opsNotes', header: 'Ops Notes', width: 'auto' },
		{ field: 'billingType', header: 'Billing Type', width: 'auto' },
		{ field: 'publicDesc', header: 'PublicDesc', width: 'auto' },
		{ field: 'contractDate', header: 'Contract Date', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.activityProviderId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			this.loading = true;
			this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-activityProvider-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}
			
			const pageNumber = Math.round(event.first / event.rows);
			this.activityProviderService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.activityProviders = res.data.activityProviders;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.activityProviders = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(activityProvider: ActivityProvider) {
		try {
			this.formLoading = true;
			this.activityProviderService.update(activityProvider)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.activityProviders.map((activityProvider, i) => {
							if (activityProvider.activityProviderId === res.data.activityProvider.activityProviderId) {
								this.activityProviders[i] = res.data.activityProvider;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(activityProvider: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(activityProvider));

			this.formLoading = true;
			this.activityProviderService.delete(activityProvider.activityProviderId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.activityProviders.splice(this.activityProviders.indexOf(activityProvider), 1);
						this.recordTotal = this.activityProviders.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'ActivityProvider ' + activityProvider.activityProviderId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'ActivityProvider ' + activityProvider.activityProviderId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add ActivityProvider'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ActivityProviderComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addActivityProviderCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(activityProvider: ActivityProvider) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			activityProvider: activityProvider,
			title: 'Edit ActivityProvider'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(ActivityProviderComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateActivityProviderCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteActivityProviderCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addActivityProviderCB(activityProvider: ActivityProvider) {
		console.log('Adding ActivityProvider: ' + JSON.stringify(activityProvider));
		// if we don't have a activityProviders array yet...
		if (!this.activityProviders) {
			this.activityProviders = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.activityProviders.unshift(activityProvider);

		// no idea what this is but it is required to update the array
		this.activityProviders = [...this.activityProviders];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivityProvider ' + activityProvider.activityProviderId + ' Added', life: 3000 });
	}

	updateActivityProviderCB(activityProvider: ActivityProvider) {
		console.log('Updating ActivityProvider: ' + JSON.stringify(activityProvider));
		let itemIndex = this.activityProviders.findIndex((item: any) => item.activityProviderId === activityProvider.activityProviderId);
		this.activityProviders[itemIndex] = activityProvider;

		// no idea what this is but it is required to update the array
		this.activityProviders = [...this.activityProviders];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivityProvider ' + activityProvider.activityProviderId + ' Updated', life: 3000 });
	}

	deleteActivityProviderCB(activityProvider: ActivityProvider) {
		console.log('Removing ActivityProvider: ' + activityProvider);
		this.activityProviders.splice(this.activityProviders.indexOf(activityProvider), 1);
		this.recordTotal = this.activityProviders.length;

		// no idea what this is but it is required to update the array
		this.activityProviders = [...this.activityProviders];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'ActivityProvider ' + activityProvider.activityProviderId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.activityProviders ? this.first === (this.activityProviders.length - this.rows) : true; }
	isFirstPage(): boolean { return this.activityProviders ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(activityProvider: any) {
		if (activityProvider?.status) {
			const status = this.statuses.find((e: any) => e.value == activityProvider.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
